import { useAppSelector } from "../../redux-store/CustomReduxHooks";
import { Outlet, useLocation } from "react-router-dom";
import NotFound from "../../pages/NotFound/NotFound";
import { UseStocksBaseDataLoader } from "./BaseDataInit/Stocks_Init_BaseData";
import { useEffect } from "react";
import { updateLoadingState } from "../Feature_Loading/Loading_Slice";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import { StockLobCode } from "../../utils/constants";

const StocksAndSecuritiesGuard = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const csAppSlice = useAppSelector((st) => st.CsAppSlice);
  const userDetails = csAppSlice.userDetails;
  const mobileNumber = state?.mobileNo || userDetails?.mobileNumber || "";
  const stocksLobId = userDetails?.customerAndLobDetails?.find(
    (item) =>
      item.LOB === StockLobCode && item.PRIMARY_SECONDARY_USER === "primary"
  );
  const { isFetching, error } = UseStocksBaseDataLoader(
    "primary",
    stocksLobId?.LOBID
  );

  useEffect(() => {
    if (isFetching) {
      dispatch(updateLoadingState(true));
    } else {
      dispatch(updateLoadingState(false));
    }
  }, [isFetching, mobileNumber]);

  return error ? (
    <NotFound
      moduleName="SS"
      pageName="StocksAndSecuritiesGuard"
      errorTitle=""
      errorMessage={error}
    />
  ) : isFetching || isEmpty(stocksLobId?.LOBID) ? (
    <></>
  ) : (
    <Outlet />
  );
};

export default StocksAndSecuritiesGuard;
